import React, { useState, useEffect } from "react";
import { Space } from "antd";
import { List, Button } from "antd-mobile";
import ajaxService from "../services/ajax-service";
import { withLocalize } from "react-localize-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Layout from "../layout";
import { masalik } from "../constants";

const MasajidList = ({ translate, activeLanguage }) => {
  const history = useHistory();
  const { state } = useLocation();
  const [masajid, setMasajid] = useState([]);

  useEffect(() => {
    const getMasajid = async () => {
      let response = await ajaxService.get("masjid");

      if (response != null) {
        setMasajid(response.data);
      }
    };
    getMasajid();
  }, []);

  const saveMasjid = (id) => {
    history.push({ pathname: "/masjid-form/" + id });
  };

  const editTimings = (id) => {
    history.push({ pathname: "/masjid-timings/" + id });
  };

  return (
    <Layout>
      <div
        style={{
          marginLeft: "30px",
          marginRight: "30px",
          height: window.innerHeight,
        }}
      >
        <List mode="card">
          <List.Item>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{translate("masajid")}</span>
              <Button color="primary" onClick={() => saveMasjid(0)}>
                {translate("add_masjid")}
              </Button>
            </div>
          </List.Item>
        </List>

        <Space size="middle" direction="vertical" style={{ width: "100%" }}>
          {masajid.map((masjid, index) => {
            const maslakKey = masalik[masjid.maslak];
            const maslakText = maslakKey ? translate(maslakKey) || "N/A" : "N/A";
            return (
              <List mode="card" key={`masjid-${index}`}>
                <List.Item>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span>
                      {activeLanguage.code === "en"
                        ? masjid.name
                        : masjid.name_ur}
                    </span>
                  </div>
                </List.Item>
                <List.Item>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span>{translate("maslak")}</span>
                    <span>{maslakText}</span>
                    {/* <span>{translate(masalik[masjid.maslak])}</span> */}
                  </div>
                </List.Item>
                <List.Item>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span>{translate("contact")}</span>
                    <span>{masjid.phone}</span>
                  </div>
                </List.Item>
                <List.Item>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Button
                      size="small"
                      color="primary"
                      onClick={() => saveMasjid(masjid.id)}
                    >
                      {translate("edit_masjid")}
                    </Button>

                    {/* <Button color='primary' onClick={() => saveMasjid(masjid.id)} >
                                                {translate('manage_events')}
                                            </Button> */}

                    <Button
                      size="small"
                      color="primary"
                      onClick={() => editTimings(masjid.id)}
                    >
                      {translate("manage_timings")}
                    </Button>
                  </div>
                </List.Item>
              </List>
            );
          })}
        </Space>
      </div>
    </Layout>
  );
};

export default withLocalize(MasajidList);
